import axios from 'axios';
import { META_DATA_KEY } from '../utils/constants';
export const getApiHeaders = () => ({
    'X-Version': WEB_PLUGIN_VERSION,
    'x-metadata': sessionStorage.getItem(META_DATA_KEY),
});
const apiClient = axios.create({
    baseURL: envConfig.OUTBOUND_SEARCH_URL,
    withCredentials: true,
});
export default apiClient;
